<template>
  <div>
      <!-- <mheade></mheade> -->
      <div v-show="tableData.length>0" style="width:1300px;margin:0 auto;" id="v-content" :style="{minHeight:Height+'px'}">       
              <!-- 表单内容 -->
         <div class="card mb-5" style="box-shadow: 10px 10px 5px #888888;">   
             <p class="mt-2 font">
                <img src="../../static/images/kucun.png" style="width:1.5rem;height:1.5rem;" class="mb-lg-1" alt=""/>
               <span class="p-1" style="text-shadow:#000 1px 0 0;background-color:#3190e8;color:#fff;box-shadow: 6px 4px 9px #888888;font-family: Helvetica Neue,Tahoma,Arial;border-radius:3px;">
               厂商库存管理
               </span>
                  <span class="float-right span_close" style="display:block;width:20px;line-height:20px;text-align:center;font-size:25px;" @click="$router.go(-1)">
                           &times;
                  </span>
               </p>
                   <div class="row ml-2 mb-2 mt-2">
                     <div class="col-lg-9">
                          <div class="row">
                             <div class="col-lg-12">
                                 <div class="row">
                                        <div class="col-lg-3">
                                   <div class="row">
                                        <div class="col-lg-6 p-0 text-center font">
                                        药品名称:
                                  </div>
                                  <div class="col-lg-6 p-0">
                                     <input type="text" class="form-control hei" v-model="searchForm.ypmc" @keydown.enter="searchEnterFun">
                                  </div> 
                                  </div>   
                               </div>
                                <div class="col-lg-3">
                                   <div class="row">
                                        <div class="col-lg-6 p-0 text-center font">
                                        产地名称:
                                  </div>
                                  <div class="col-lg-6 p-0">
                                     <input type="text" class="form-control font" v-model="searchForm.cdmc"  style="height:1.5rem" @keydown.enter="searchEnterFun">
                                  </div> 
                                  </div>   
                               </div>
                                <div class="col-lg-3">
                                   <div class="row">
                                        <div class="col-lg-6 p-0 text-center font">
                                        产品规格:
                                  </div>
                                  <div class="col-lg-6 p-0">
                                     <input type="text" class="form-control font" v-model="searchForm.gg"  style="height:1.5rem" @keydown.enter="searchEnterFun">
                                  </div> 
                                
                                  </div>   
                               </div>    
                                <div class="col-lg-3">
                                   <div class="row">
                                        <div class="col-lg-6 p-0 text-center font">
                                        产品批号:
                                  </div>
                                  <div class="col-lg-6 p-0">
                                     <input type="text" class="form-control font" v-model="searchForm.ph"  style="height:1.5rem" @keydown.enter="searchEnterFun">
                                  </div> 
                                  </div>   
                               </div>
                                 </div>
                                   
                             </div>
                               
                          </div>

                       </div>
                        <div class="col-lg-3">
                          <div class="row ml-lg-5 hei" style="margin-left:242px;">            
                                 <button class="bg-primary button_zi" @click="Search()">开始查询</button>
                                 <button class="bg-success button_zi ml-lg-3" @click="start_print()">打印页面</button>
                                 <button class="bg-success button_zi ml-lg-3" @click="exportExcel()">导出全部数据</button>
                             
                      </div>
                  </div>
                </div> 
                   
           <table v-if="searchData.length>0"  class="table table-striped table-hover" ref="print">
               <thead>
                    <tr style="white-space: nowrap;">
                        <th>药品名称</th>
                        <th>药品代码</th>
                        <th>产地名称</th>
                        <th>规格</th>
                        <th>批号</th>
                        <th>单位</th>
                        <th>包装</th>
                        <th class="text-center">数量</th>
                        <th>入库日期</th>
                      </tr>
               </thead>
               <tbody>
                    <tr v-for="(item,index) in searchData" :key="index">
                            <td @dblclick="onInputdrugName(index)">{{item.drugName}}</td>
                              <td>{{item.drugCode}}</td>
                              <td @dblclick="onInputcustomerName(index)">{{item.addr}}</td>
                              <td>{{item.spec}}</td>
                              <td>{{item.batchNo}}</td>
                              <td>{{item.unit}}</td>
                              <td>{{item.unit}}</td>
                              <td class="text-center">{{item.num}}</td>
                              <td>{{item.date|formatUTC}}</td>    
                  </tr>
               </tbody>

            </table>
            <table class="table table-striped table-hover" ref="print" v-else>
                    <thead>
                      <tr style="white-space: nowrap;">
                        <th>药品名称</th>
                        <th>药品代码</th>
                        <th>产地名称</th>
                        <th>规格</th>
                        <th>批号</th>
                        <th>单位</th>
                        <th>包装</th>
                        <th>数量</th>
                        <th>入库日期</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item,index) in tableData" :key="index">
                              <td @dblclick="onInputdrugName(index)">{{item.drugName}}</td>
                              <td>{{item.drugCode}}</td>
                              <td @dblclick="onInputcustomerName(index)">{{item.addr}}</td>
                              <td>{{item.spec}}</td>
                              <td>{{item.batchNo}}</td>
                              <td>{{item.unit}}</td>
                              <td>{{item.unit}}</td>
                              <td>{{item.num}}</td>
                              <td>{{item.date|formatUTC}}</td>
                              
                      </tr>
                    </tbody>
                  </table>
                  <!-- 分页 -->
    <nav aria-label="Page navigation" style="text-align:center;" class="mb-1">
      <ul class="pagination">
        <li class="page-item ml-5" :class="PageNo<=1?'disabled':''" @click="prePage()">
          <a aria-label="Previous" class="page-link">
            <span aria-hidden="true">&laquo;</span>
          </a>
        </li>
           <li :class="index==PageNo?'active':''" class="page-item" v-for="index of Pcount" :key="index"
                                                @click="curPage(index)">
                                                <a class="page-link" v-if="index<=20">{{index}}</a>
                                                <a class="page-link" v-if="index>20 && index==(Pcount-1)">...</a>
                                                <a class="page-link" v-if="index>20 && index==Pcount">{{Pcount}}</a>
                                            </li>
        <li class="page-item" :class="PageNo>=Pcount?'disabled':''" @click="nextPage()">
          <a aria-label="Next" class="page-link" >
            <span aria-hidden="true">&raquo;</span>
          </a>
        </li>
          <li class="ml-5">
            <span class="d-block mt-2">
              总共有
              <span style="color:green;font-size:20px">{{Record}}</span>
              条数据
            </span>
          </li>
      </ul>
    </nav>
     <p class="text-center">
        <img src="../../static/images/tuding.png" style="width:1.5rem;height:1.5rem;" alt=""/>
      </p>
  </div> 
    
       <!-- container -->   
          

      </div>

                 <div v-show="Pcount===0" style="width:1300px;margin:0 auto;" id="v-content" :style="{minHeight:Height+'px'}">       
              <!-- 表单内容 -->
         <div class="card mb-5" style="box-shadow: 10px 10px 5px #888888;">   
             <p class="mt-2 font">
                <img src="../../static/images/kucun.png" style="width:1.5rem;height:1.5rem;" class="mb-lg-1" alt=""/>
               <span class="p-1" style="text-shadow:#000 1px 0 0;background-color:#3190e8;color:#fff;box-shadow: 6px 4px 9px #888888;font-family: Helvetica Neue,Tahoma,Arial;border-radius:3px;">
               厂商库存管理
               </span>
                  <span class="float-right span_close" style="display:block;width:20px;line-height:20px;text-align:center;font-size:25px;" @click="$router.go(-1)">
                           &times;
                  </span>
               </p>
                   <div class="row ml-2 mb-2 mt-2">
                     <div class="col-lg-9">
                          <div class="row">
                             <div class="col-lg-12">
                                 <div class="row">
                                        <div class="col-lg-3">
                                   <div class="row">
                                        <div class="col-lg-6 p-0 text-center font">
                                        药品名称:
                                  </div>
                                  <div class="col-lg-6 p-0">
                                     <input type="text" class="form-control hei" v-model="searchForm.ypmc" @keydown.enter="searchEnterFun">
                                  </div> 
                                  </div>   
                               </div>
                                <div class="col-lg-3">
                                   <div class="row">
                                        <div class="col-lg-6 p-0 text-center font">
                                        产地名称:
                                  </div>
                                  <div class="col-lg-6 p-0">
                                     <input type="text" class="form-control font" v-model="searchForm.cdmc"  style="height:1.5rem" @keydown.enter="searchEnterFun">
                                  </div> 
                                  </div>   
                               </div>
                                <div class="col-lg-3">
                                   <div class="row">
                                        <div class="col-lg-6 p-0 text-center font">
                                        产品规格:
                                  </div>
                                  <div class="col-lg-6 p-0">
                                     <input type="text" class="form-control font" v-model="searchForm.gg"  style="height:1.5rem" @keydown.enter="searchEnterFun">
                                  </div> 
                                
                                  </div>   
                               </div>    
                                <div class="col-lg-3">
                                   <div class="row">
                                        <div class="col-lg-6 p-0 text-center font">
                                        产品批号:
                                  </div>
                                  <div class="col-lg-6 p-0">
                                     <input type="text" class="form-control font" v-model="searchForm.ph"  style="height:1.5rem" @keydown.enter="searchEnterFun">
                                  </div> 
                                  </div>   
                               </div>
                                 </div>
                                   
                             </div>
                               
                          </div>

                       </div>
                        <div class="col-lg-3">
                          <div class="row ml-lg-5 hei" style="margin-left:242px;">            
                                 <button class="bg-primary button_zi" @click="Search()">开始查询</button>
                                 <button class="bg-success button_zi ml-lg-3" @click="start_print()">打印页面</button>
                                 <button class="bg-success button_zi ml-lg-3" @click="exportExcel()">导出全部数据</button>
                             
                      </div>
                  </div>
                </div> 
                     <img src="../../static/images/wushuju.jpg" style="width:300px;height:300px;display:block;margin:0 auto;" alt="">
     <p class="text-center">
        <img src="../../static/images/tuding.png" style="width:1.5rem;height:1.5rem;" alt=""/>
      </p>
  </div> 
    
       <!-- container -->   
          

      </div>


                <div>
                  <transition name="fade">
                           <loading v-if="isLoading">
                           </loading>
                  </transition>
                </div>
  <!-- Footer -->
         <!-- <mfooter></mfooter> -->
     </div>
</template>
<script>
// import mheade from '../components/vender/Heade.vue'
// import mfooter from '../components/Footer.vue'
import Loading from '../components/Loading.vue'
export default {
      name: 'SaleQuery',
    data () {
      return {
         Height:0,
        searchForm: {
          ypmc: '',
          cdmc: '',
          ph: '',
          gg: '',
        },//搜索内容
        searchData:[],//搜索返回的清单
        isLoading: false,
        tableData: [],
        Record:'',//总记录数
        Pcount:'',//总页数
        PageNo:1,//当前页码
        listData:[]
      }
    },
    components:{
        // mheade,
        // mfooter,
        Loading
    },
    computed:{
         
},
filters: {
  //过滤器时间转换
  //时间转换
      formatUTC:function(utc_datetime) {
        // 转为正常的时间格式 年-月-日 时:分:秒
           return utc_datetime.replace(/T/ig,"  ").substring(0,20)
        } ,
},

methods: {
  searchEnterFun(e){
         var keyCode = window.event ? e.keyCode : e.which;
         if(keyCode == 13){
           this.Search();
         }
      },
    //验证
        //  ypmc:function(){
        //       let reg1=/^[\u4e00-\u9fa5]{0,}$/;
        //        if(!reg1.test(this.searchForm.ypmc)){
        //              $("#ypmc").removeClass("d-none")
        //        }
        //        else{
        //             $("#ypmc").addClass("d-none")
        //        }
        //   },
        //   ph:function(){
        //        let reg2=/^[0-9]*$/;
        //        if(!reg2.test(this.searchForm.ph)){
        //              $("#ph").removeClass("d-none")
        //        }
        //        else{
        //             $("#ph").addClass("d-none")
        //        }
        //   },
        //   cdmc:function(){
        //         let reg3=/^[\u4e00-\u9fa5]{0,}$/;
        //         if(!reg3.test(this.searchForm.cdmc)){
        //              $("#cdmc").removeClass("d-none")
        //        }
        //        else{
        //              $("#cdmc").addClass("d-none")
        //        }
        //   },
    onInputdrugName:function(index){
          if(this.searchData.length>0){
            this.searchForm.ypmc=this.searchData[index].drugName;
          }
          else {
            this.searchForm.ypmc=this.tableData[index].drugName;
          }
      },
      onInputcustomerName:function(index){
          if(this.searchData.length>0)
          {
             this.searchForm.cdmc=this.searchData[index].addr
          }
          else
          {
            this.searchForm.cdmc=this.tableData[index].addr;
          }  
      },
      getFactorySale: async function (PageIndex) {
          //  this.isLoading=true;
          this.PageNo=PageIndex || this.PageNo
        const { data: res } = await this.$http.post('Dls/getFun', {
          action: 'FactoryStore',
          obj: JSON.stringify({
             PageIndex,
             PageSize:20
          })
        })
        // console.log(res)
        if (res.isok) {
          const obj = res.data
          this.tableData = obj.rows
          this.Pcount = obj.pcount
          this.Record = obj.record
          // this.isLoading=false
          /*
          {
          drugName: '白癜风丸',
          productFactory: '吉林省银诺克药业有限公司',
          spec: '36s',
          batchNum: '20190204',
          unit: '盒',
          price: 5.5,

        }
          * */
        }
      },
       //导出全部数据
       exportExcel() {
                 const that=this
                require.ensure([], async () => {
                  const { export_json_to_excel } = require('../Excel/Export2Excel');//注意这个Export2Excel路径
                  const tHeader = ["药品名称","药品代码","产地名称","规格","批号","单位","数量","入库日期"]; // 上面设置Excel的表格第一行的标题
            
                  const filterVal = ['drugName', 'drugCode', 'addr','spec','batchNo','unit','num','date']; // 上面的index、nickName、name是tableData里对象的属性key值
                       await that.getListData()
                      const list = that.listData
                     const data = that.formatJson(filterVal, list);
                     export_json_to_excel(tHeader, data, '厂家入库');//最后一个是表名字
                })
              },
              formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
              },


        getListData: async function () {
        const {data: res} = await this.$http.post('Dls/getFun', {
          action: 'FactoryStore',
          obj: JSON.stringify({
            PageIndex:1,
            PageSize: 50000,
            DrugName: this.searchForm.ypmc.trim(),
            BatchNo: this.searchForm.ph.trim(),
            Addr: this.searchForm.cdmc.trim(),
            Spec: this.searchForm.gg.trim(),
          })
        })
        // console.log(res)
        if (res.isok) {
          const that=this
          const obj = res.data
          that.listData = obj.rows
        
          
        }
      },
      //搜索

        Search: async function (PageIndex) {
      
        const that = this
        // search 是 v-model="search" 的 search
          that.isLoading=true;
         if(!PageIndex){PageIndex=1}
        that.PageNo = PageIndex || that.PageNo
        const {data: res} = await this.$http.post('Dls/getFun', {
          action: 'FactoryStore',
          obj: JSON.stringify({
            PageIndex,
            PageSize: 20,
            DrugName: that.searchForm.ypmc.trim(),
            BatchNo: that.searchForm.ph.trim(),
            Addr: that.searchForm.cdmc.trim(),
            Spec: that.searchForm.gg.trim(),
          })
        })
        // console.log(res)
        if(res.isok){
              const obj = res.data
              that.searchData = obj.rows
              that.Pcount = obj.pcount
              that.Record = obj.record
              that.isLoading=false;
              if(obj.pcount==0){
                    alert('没有符合条件的信息')
                     that.getFactorySale();
              }
              
        }

        },

     curPage: function (index) {
         if(this.searchData.length>0){
            this.Search(index)
         }
         else{
           this.getFactorySale(index)
         }
      },
      //上一页
      prePage: function () {
        if (this.PageNo > 1) {
          this.PageNo--;
           if(this.searchData.length>0){
            this.Search(this.PageNo)
          }
          else{

            this.getFactorySale(this.PageNo);
          }
        }
      },
      //下一页
      nextPage: function () {
        if (this.PageNo < this.Pcount) {
          this.PageNo++;
          if(this.searchData.length>0){
            this.Search(this.PageNo)
          }
          else{

            this.getFactorySale(this.PageNo);
          }
        }
      },
      //搜索功能
    
      
     // 打印
    start_print(){
        this.$print(this.$refs.print);//$refs的值要和html里的ref一致
    }

    },
     mounted(){
          //动态设置内容高度 让footer始终居底   header+footer的高度是100
    this.Height = document.documentElement.clientHeight - 100;  
　　//监听浏览器窗口变化　
    window.onresize = ()=> {this.Height = document.documentElement.clientHeight -100}
  
    },
     created () {
        this.getFactorySale();
        this.getListData();
        
      
    }
}
</script>
<style scoped>
   .table-hover>tbody>tr:hover {
    background-color:#dee2e6!important;
}
.font{
  font-size:15px;
}
.hei{
  height:1.5rem;
}
.font_yz{
  font-size:1px;
  color:red;
}
.button_zi{
      text-shadow:#000 1px 0 0;
      border-radius: 5px;
      border:none;
      color:azure;
  }
  .span_close:hover{
       color:#3190e8;
 }
</style>



// WEBPACK FOOTER //
// src/pages/FactoryStore.vue